import { forwardRef } from 'react';

import { Svg, SvgProps } from '../../components/Svg/Svg.styles';

export const InboxIcon = forwardRef<SVGSVGElement, SvgProps>((props, ref) => (
  <Svg {...props} ref={ref} width="16" height="16" viewBox="1 1 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" data-no-fill>
    <path d="M2.8125 9.5625H6.05265C6.31594 10.9505 7.53541 12 9 12C10.4646 12 11.6841 10.9505 11.9474 9.5625L15.1875 9.5625M12.9375 15.1875H5.06251C3.81986 15.1875 2.8125 14.1801 2.81251 12.9375L2.81253 5.06249C2.81254 3.81986 3.81989 2.8125 5.06253 2.8125L12.9375 2.8125C14.1801 2.8125 15.1875 3.81986 15.1875 5.0625V12.9375C15.1875 14.1801 14.1801 15.1875 12.9375 15.1875Z" stroke="currentcolor" strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round" />
  </Svg>
));
